import React from 'react';
import Skeleton from '@components/atoms/Skeleton/Skeleton';
import { SkeletonWrapper } from './HorizontalBannerComponent.skeleton.styles';
import useResponsive from '@hooks/useResponsive';

const HorizontalBannerComponentSkeleton = () => {
  const { fromTabletPortrait } = useResponsive();

  return (
    <SkeletonWrapper data-testid="horizontalbanner-skeleton">
      <Skeleton type="rect" height={fromTabletPortrait ? 310 : 232} />
    </SkeletonWrapper>
  );
};

export default HorizontalBannerComponentSkeleton;
